module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"col-md-12\" style=\"padding:0;\">\r\n    <h2 style=\"margin: 10px 0 5px 0;\">General</h2>\r\n    <div class=\"row\" style=\"padding-right: 0;\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Name</span>\r\n        </div>\r\n        <div class=\"col-sm-9\" >\r\n            <input type=\"text\" name=\"_name\" value=\"")
    ; __append(escapeFn( currentActionDetails.Name ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" style=\"padding-right: 0;\">\r\n        <div class=\"col-sm-3\">\r\n            <span>Type</span>\r\n        </div>\r\n        <div class=\"col-sm-7\">\r\n            ")
    ;  switch (currentActionDetails.Type.slice(0,-1)) {
            case '1':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"11\">SELECT</option>\r\n                <option value=\"12\">UPDATE</option>\r\n                <option value=\"10\">INSERT</option>\r\n                <option value=\"14\">DELETE</option>\r\n                <option value=\"13\">Stored Procedure</option>\r\n            </select>\r\n            ")
    ;  break;
            case '2':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"21\">SELECT</option>\r\n                <option value=\"22\">UPDATE</option>\r\n                <option value=\"20\">INSERT</option>\r\n                <option value=\"23\">DELETE</option>\r\n            </select>\r\n            ")
    ;  break;
            case '3':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"30\">String Result</option>\r\n                <option value=\"31\">XML Result</option>\r\n            </select>\r\n            ")
    ;  break;
            case '4':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"40\">Read</option>\r\n                <option value=\"41\">Insert</option>\r\n                <option value=\"42\">Update</option>\r\n            </select>\r\n            ")
    ;  break;
            case '8':
    ; __append("\r\n            <select name=\"_type\">\r\n                <!--<option value=\"81\">READ</option>-->\r\n                <option value=\"83\">UPDATE</option>\r\n                <option value=\"82\">INSERT</option>\r\n                <option value=\"84\">DELETE</option>\r\n                <option value=\"85\">SELECT</option>\r\n            </select>\r\n            ")
    ;  break;
            case '7':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"71\">SELECT</option>\r\n                <option value=\"70\">INSERT</option>\r\n                <option value=\"72\">UPDATE</option>\r\n                <option value=\"73\">DELETE</option>\r\n            </select>\r\n            ")
    ;  break;
            case '11':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"110\">GET</option>\r\n                <option value=\"111\">POST</option>\r\n                <option value=\"112\">PUT</option>\r\n                <option value=\"113\">DELETE</option>\r\n            </select>\r\n            ")
    ;  break;
            case '12':
    ; __append("\r\n            <select name=\"_type\">\r\n                <option value=\"120\">QUERY</option>\r\n                <option value=\"122\">UPSERT</option>\r\n                <option value=\"123\">DELETE</option>\r\n            </select>\r\n            ")
    ;  break;
            }
            
    ; __append("\r\n\r\n        </div>\r\n        <div class=\"col-sm-2\">\r\n            <input type=\"checkbox\" style=\"margin-top: 6px;float: left;margin-right: 5px;\"\r\n                        name=\"_active\" ")
    ; __append(escapeFn( currentActionDetails.ActionXML.Action['_active'] === 'true' ? " checked" : "" ))
    ; __append(" />      \r\n                        <div style=\"float:left; margin-top: 5px;\">Active</div>              \r\n        </div>\r\n       \r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}